// import { useEffect, useState } from "react";
import { getDaysDifferenceAbs } from "../../../lib/dateScripts";
import { frontendOptions } from "../../../lib/systemData";
import { getCaseIdFromCasePayload } from "../../../lib/caseUpdateHelpers";

export default function WorkQRowTrWrapper({ children, index, activeCaseId, data, classes, workq, deferRowPaint }) {


    let optionalClasses = ''

    const matchesRange = (days, range) => {
        if (!range || typeof range !== "object") return false
        const minOk = range.min == null || days >= Number(range.min)
        const maxOk = range.max == null || days <= Number(range.max)
        return minOk && maxOk
    }

    const rowClassForColor = (color) => {
        const c = String(color || '').trim().toLowerCase()
        if (c === 'red') return 'table_row_red_background'
        if (c === 'yellow') return 'table_row_yellow_background'
        if (c === 'orange') return 'table_row_orange_background'
        return ''
    }

    // if (workq.complex_filtering == "GDQ") {
        
    //     if (workQFunctions.numberOfDaysSinceLastVisitHasPassed(data?.case)) {
    //         optionalClasses = 'table_row_yellow_background';
    //     }

    //     aicaDataOptions.some(item => {
    //         const isStatusHoldAndDaysHavePassed = aicaDepartmentFunctions.isStatusHoldAndDaysHavePassed(data?.aica_department_status, item.prefix);
    //         if (isStatusHoldAndDaysHavePassed) {
    //             optionalClasses = 'table_row_orange_background';
    //         }
    //     });

    //     if (workQFunctions.numberOfDaysSinceinPendingDischarged(data?.case)) {
    //         optionalClasses = 'table_row_orange_background';
    //     }
    // }


    if (workq?.complex_filtering == "negotiation") {
        const payerStatusDate = data?.case?.case_payer_status_date

        if (!payerStatusDate) {
            optionalClasses = 'table_row_red_background';
        } else {
            const daysInQueue = getDaysDifferenceAbs(payerStatusDate)
            if (daysInQueue >= 3) {
                optionalClasses = 'table_row_red_background';
            } else if (daysInQueue == 2) {
                optionalClasses = 'table_row_yellow_background';
            }
        }
    }

    if (workq?.complex_filtering == "escalation") {
        const escalateDate = data?.case_negotiation?.escalate_negotiation_date
        if (escalateDate) {
            const daysInQueue = getDaysDifferenceAbs(escalateDate)
            const escalationSettings = frontendOptions()?.ESCALATION_SETTINGS
            if (daysInQueue != null && escalationSettings && typeof escalationSettings === 'object') {
                // Expecting: { red: {min,max}, yellow: {min,max}, orange?: {min,max}, ... }
                const priority = ['red', 'orange', 'yellow']
                for (const color of priority) {
                    const range = escalationSettings?.[color]
                    if (matchesRange(daysInQueue, range)) {
                        optionalClasses = rowClassForColor(color)
                        break
                    }
                }

                if (!optionalClasses) {
                    for (const [color, range] of Object.entries(escalationSettings)) {
                        if (matchesRange(daysInQueue, range)) {
                            optionalClasses = rowClassForColor(color)
                            if (optionalClasses) break
                        }
                    }
                }
            }
        }
    }

    const rowCaseId = data ? getCaseIdFromCasePayload(data) : null
    const isActiveRow =
        activeCaseId != null &&
        rowCaseId != null &&
        Number(activeCaseId) === Number(rowCaseId)

    return (
        <tr
            className={`table-patient-row ${classes.patient_row} ${index % 2 == 0 ? classes.patient_row_odd : ""} ${isActiveRow ? classes.patient_row_active : ""} ${optionalClasses}`}
            style={
                deferRowPaint
                    ? {
                          contentVisibility: "auto",
                          /* Must match WORKQ_VIRTUAL_ROW_ESTIMATE_PX in WorkQComponent.js (tbody virtual padding) */
                          containIntrinsicSize: "auto 58px",
                      }
                    : undefined
            }
        >
            {children}
        </tr>
    )
}